import { Box } from '@mui/material';
import { useIsMutating } from '@tanstack/react-query';
import { getMissingApprovals } from 'lib/api/approvals';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { useComiteeTabContext } from './ComiteeTabProvider';
import CommitteeChangeDialog from './CommitteeChangeDialog';
import CommitteeInfoCard from './CommitteeInfoCard';
import CommitteeTabs from './CommitteeTabs';

const Committee = () => {
  const dispatch = useDispatch();
  const [openCommitteeChange, setOpenCommitteeChange] = useState(false);

  const { requestType, requestId, comiteeType, comiteeId } =
    useComiteeTabContext();

  const isUpdating =
    useIsMutating({
      mutationKey: [
        'approvals',
        'updateComitee',
        requestType,
        requestId,
        comiteeType,
      ],
    }) > 0;

  const { isPending } = getMissingApprovals(
    dispatch,
    requestType,
    requestId,
    comiteeType,
  );

  const handleEditCommitteeClick = () => {
    setOpenCommitteeChange(true);
  };

  return (
    <Box sx={{ my: 2 }}>
      <CommitteeInfoCard onEditClick={handleEditCommitteeClick} />

      {!isPending && !isUpdating && comiteeId && <CommitteeTabs />}

      {openCommitteeChange && (
        <CommitteeChangeDialog
          open={openCommitteeChange}
          setOpen={setOpenCommitteeChange}
          onCancel={() => setOpenCommitteeChange(false)}
        />
      )}
    </Box>
  );
};

export default Committee;
